import React from 'react';
import { useSelector } from 'react-redux';
import { TTRestaurantProfile } from '../../interfaces/restaurant';
import { RootState } from '../../rootReducer';
import TableTabBanner from '../components/TableTabBanner';
import ViewHeader from '../components/ViewHeader';
import RestaurantNameCard from '../Menu/Menus/components/RestaurantNameCard';

type Props = {};

export function OrderClosedThankYou(props: Props) {
  const profile = useSelector<RootState, TTRestaurantProfile | null>(
    state => state.restaurant.profile,
  );
  return (
    <>
      <div className="min-h-screen bg-background ">
        <div
          className={
            'flex flex-col pt-4 p-4 overflow-y-auto scrolling-touch bg-background'
          }
        >
          <ViewHeader title="Thank you!" className={'text-left px-2'} />
          <RestaurantNameCard
            restaurant_name={profile?.name}
            bio={profile?.bio}
            profile_image_url={profile?.main_profile_image}
          />
          <div className={'mt-8 w-full'}>
            <TableTabBanner applyFilter={false} />
          </div>
        </div>
      </div>
    </>
  );
}
